import styled from 'styled-components';
import { getBreakpoint } from '$util/theme/breakpoints';

export const Wrapper = styled.div`
  @media (max-width: ${getBreakpoint('sm')}) {
    .full {
      display: none;
    }
  }
  @media (min-width: ${getBreakpoint('sm')}) {
    .full {
      padding-left: 85px;
      padding-right: 59px;
    }
    .mini {
      display: none;
    }
  }
`;

export const MiniWrapper = styled.div`
  padding: 0px 15px;
`;
